import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function GraphProcurementBreakdown({ summaryReports, id, title, gColor, xAxistitle }) {
    let component1InvestmentValues;
    let component2InvestmentValues;
    let financialDataValuesSKU;
    let financialDataKeysSKU;
    const chartRef = useRef(null);
    if (id === "SKU1") {
        component1InvestmentValues = summaryReports?.FinancialAnalysis?.component1Investment;
        financialDataValuesSKU = component1InvestmentValues ? Object.values(component1InvestmentValues) : null;
        financialDataKeysSKU = component1InvestmentValues ? Object.keys(component1InvestmentValues) : null;
    }
    else {
        component2InvestmentValues = summaryReports?.FinancialAnalysis?.component2Investment;
        financialDataValuesSKU = component2InvestmentValues ? Object.values(component2InvestmentValues) : null;
        financialDataKeysSKU = component2InvestmentValues ? Object.keys(component2InvestmentValues) : null;
    
    }

    function applyDemandVarianceAccessibility(chart) {
        if (chart && chart.renderTo) {
            const svg = chart.renderTo.querySelector("svg");
             // Defensive fallback for missing id
            if (!chart.renderTo.id) {
            chart.renderTo.id = "fallback-id-" + Math.random().toString(36).substr(2, 5);
            console.warn("Chart renderTo had no id. Assigned fallback id:", chart.renderTo.id);
            }
            if (svg) {
            setTimeout(() => {
            const chartId = chart.renderTo.id;

            let ariaLabel = '';
            let descText = '';

            if (chartId === "SKU1") {
                ariaLabel = "Bar chart showing order costs for SKU1 suppliers.";
                descText = "This chart shows the total budget spent on SKU1 across various suppliers. Each bar represents the order cost associated with the respective supplier.";
            } else if (chartId === "SKU2") {
                ariaLabel = "Bar chart showing order costs for SKU2 suppliers.";
                descText = "This chart displays the total budget spent on SKU2 from different suppliers. Each bar indicates the cost of orders placed with each supplier.";
            }

            svg.setAttribute("role", "img");
            svg.setAttribute("aria-label", ariaLabel);

            const oldDesc = svg.querySelector("desc");
            if (oldDesc) oldDesc.remove();

            const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
            desc.textContent = descText;
            svg.insertBefore(desc, svg.firstChild);
            },0);
            }
        }
    }

    var chart = {
        type: 'column',
        events: {
            render: function () {
            setTimeout(() => applyDemandVarianceAccessibility(this),100);
            },
            redraw: function () {
            setTimeout(() => applyDemandVarianceAccessibility(this),100);
            }
        }
    };
    var title = {
        text: `${title}`,
        align: "left",
        style: {
            fontSize: "14px",
        },
    };
    var credits = {
        enabled: false, // Disable the Highcharts bottom link
    };
    var tooltip = {
        // format: '<strong>{key}</strong><br/>{series.name}: <strong>{y}</strong><br/>',
        formatter: function () {
            var tooltipText = `<strong>${this.x}</strong>` + '<br/>';
            var seriesColor = `${gColor}`;
            if (this.series.name === "Order Cost") {
                tooltipText += `<span style="color: ${seriesColor}">` + this.series.name + `</span>: <strong style="font-weight: bold;">$` + Highcharts.numberFormat(this.y, 0, ',', ',') + `</strong>`;
            }
            return tooltipText;
        },
        borderWidth: 1,
        style: {
            borderColor: function () {
                return this.point.color; // Set the tooltip box border color to match the point color
            },
            opacity: 0.9,
            fontSize: '14px',
        }
    };
    var legend = {
        enabled: false,
        align: "left",
        itemStyle: {
            fontWeight: "bold",
            fontSize: "11px",
        },
    };

    var plotOptions = {
        column: {

            dataLabels: {
                enabled: false,
                style: {
                    textOutline: "none",
                },
            },
        },
        series: {
            events: {
                legendItemClick: function () {
                    return false;
                }
            }
        }
    };
    var series = [
        {
            name: "Order Cost",
            //data: [summaryReports?.DemandAnalysis?.forecastedDemands?.REGULAR,summaryReports?.DemandAnalysis?.forecastedDemands?.MIDGRADE,summaryReports?.DemandAnalysis?.forecastedDemands?.PREMIUM],
            data: financialDataValuesSKU,
            //color: `${gColor}`,
            color: {
                pattern: {
                  path: gColor === "#D46719" ? 'M 0 0 L 10 10 M 9 -1 L 11 1 M -1 9 L 1 11' : 'M 0 10 L 10 0',
                  width: 10,
                  height: 10,
                  color: '#FFFFFF',
                  backgroundColor: `${gColor}`
        
                }
              },

        }
    ];
    var xAxis = {
        categories: financialDataKeysSKU,
        title: {
            text: `${xAxistitle}`,
        },
        lineColor: '#EFEFEC',
        labels: {
            step: 1,
            padding: 0,
            rotation: -45,
        },
    }
    var yAxis = {
        allowDecimals: false,
        crosshair: true,
        min: 0,
        title: {
            text: "Budget Spent"
        }
    }
    var accessibility = {
        enabled: true,
        screenReaderSection: {
            beforeChartFormat: '' // disables their auto "Interactive chart" label
        }
    };
    var json = {};
    json.chart = chart;
    json.credits = credits;
    json.title = title;
    json.tooltip = tooltip;
    json.legend = legend;
    json.series = series;
    json.xAxis = xAxis;
    json.yAxis = yAxis;
    json.plotOptions = plotOptions;
    json.accessibility = accessibility;
    // const initGraph = () => {
    //     Highcharts.chart(`${id}`, json);
    //     //console.log(json);
    // };
    const initGraph = () => {
        if (chartRef.current) {
            if (!chartRef.current.id) {
            chartRef.current.id = id;
            }

            const chartOptions = {
            ...json,
            chart: {
                ...json.chart,
                renderTo: chartRef.current, // optional (but safe)
                type: 'column',
                events: {
                render: function () {
                    setTimeout(() => applyDemandVarianceAccessibility(this), 100);
                },
                redraw: function () {
                    setTimeout(() => applyDemandVarianceAccessibility(this), 100);
                }
                }
            }
            };

            Highcharts.chart(chartRef.current, chartOptions);
        }
    };
    useEffect(() => {
        initGraph();
    }, [summaryReports]);
    return (
        <div
            // id={id}
            ref={chartRef}
            style={{ height: "500px" }}
            title={title.text}
            aria-label="Financial Analysis Graph"
            className="FinancialAnalysis"
        ></div>
    );
}
